import { message } from "antd";
import axiosInstance from "../shared/axios";

const getActivityLogs = async (params) => {
  try {
    const result = await axiosInstance.get("/logs/viewAll", {
      params: {
        fromDate: params?.fromDate || "",
        toDate: params?.toDate || "",
        pageNo: params?.pageNo,
        recordsPerPage: params?.recordsPerPage,
      },
    });
    if (result?.status === 200 && result?.data?.success) {
      return {
        data: result?.data?.data || [],
        total: result?.data?.totalRecords || 0,
      };
    } else {
      message.error("Error while loading activity logs");
      return { data: [], total: 0 };
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading activity logs",
    );
    return { data: [], total: 0 };
  }
};

export const activitylogapi = {
  getActivityLogs,
};
